// extracted by mini-css-extract-plugin
export default {"label":"style_label__jznSP","inputContainer":"style_inputContainer__BOqK+","input":"style_input__EyKon","symbolContainer":"style_symbolContainer__5Ww2n"};